import { axiosUnos } from "../axios/unos_axios";

export const testContentGet = async (): Promise<string> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosUnos.get("test-content");
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};
